// extracted by mini-css-extract-plugin
module.exports = {"drawerfooter":"styles_drawerfooter__1QLkr"};